import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import ClearIcon from '@mui/icons-material/Clear';
import { Avatar, Box, Drawer, IconButton, Skeleton, SxProps, Typography } from '@mui/material';
import { Stack } from '@mui/system';

const EMS_BENEFITS_CONTENT = 'DPCV2BeneficiosTiendaDrawer';

const DistributorInfoDrawerContent = () => (
	<ContentRecommendation
		id={EMS_BENEFITS_CONTENT}
		properties={{ emsName: EMS_BENEFITS_CONTENT }}
		withoutFrame
		loadingElement={
			<Skeleton
				sx={{
					width: '100%',
					height: '200px',
				}}
			/>
		}
	/>
);

export const DrawerBenefitContainerSX: SxProps = {
	'& .MuiDrawer-paper': {
		borderRadius: '8px 8px 0 0',
		overflow: 'hidden',
	},
	position: 'relative',
};

export const DrawerBenefitContentSX: SxProps = {
	maxHeight: '70vh',
	position: 'relative',
	overflow: 'auto',
	transition: 'height 0.3s ease-in-out !important',
};

export const DrawerBenefitHeaderSX: SxProps = {
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	position: 'sticky',
	top: 0,
	zIndex: 1000,
	backgroundColor: '#E0F3FF',
	padding: '15px 20px',
};

export const DrawerBenefitHeaderTitleSX: SxProps = {
	fontSize: 'var(--font-size-lg)',
	fontWeight: 800,
	textTransform: 'uppercase',
	color: '#2C2C2C',
	mb: '20px',
};

interface DistributorInfoDrawerProps {
	open: boolean;
	distributorAvatar?: string;
	distributorName?: string;
	onClose: () => void;
}

export const DistributorInfoDrawer = ({
	open,
	distributorAvatar,
	distributorName,
	onClose,
}: DistributorInfoDrawerProps) => (
	<Drawer
		anchor="bottom"
		open={open}
		keepMounted
		sx={DrawerBenefitContainerSX}
		onClose={onClose}
		BackdropProps={{
			sx: {
				animationDuration: '0.3s !important',
				transitionDuration: '0.3s !important',
				transition: 'background-color 0.3s ease-in-out, opacity 0.3s ease-in-out !important',
				animation: 'ease-in-out !important',
				transform: 'background-color 0.3s ease-in-out, opacity 0.3s ease-in-out !important',
			},
		}}
	>
		<Box sx={DrawerBenefitContentSX}>
			<Box sx={DrawerBenefitHeaderSX}>
				<Stack
					sx={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						gap: '10px',
					}}
				>
					{distributorName ? (
						<Avatar src={distributorAvatar} sx={{ width: '51px', height: '51px' }} />
					) : null}
					<Typography
						sx={{
							fontSize: '17px',
							fontWeight: 'bold',
							paddingRight: '35px',
							textTransform: 'uppercase',
						}}
					>
						{distributorName
							? `BIENVENIDO A TU CATALOGO DP DISTRIBUDOR: ${distributorName}`
							: 'BIENVENIDO A TU CATALOGO'}
					</Typography>
				</Stack>
				<Box sx={{ position: 'absolute', top: 0, right: 0 }}>
					<IconButton
						color="inherit"
						onClick={onClose}
						sx={{
							'&:hover': {
								backgroundColor: 'transparent',
								color: 'inherit',
							},
							padding: '16px 14px',
						}}
					>
						<ClearIcon color="inherit" fontSize="inherit" />
					</IconButton>
				</Box>
			</Box>
			<Box paddingX="12px" marginBottom="38px" marginTop="20px">
				<DistributorInfoDrawerContent />
				<DpButton variant="primary" fullWidth sx={{ marginTop: '10px' }} onClick={onClose}>
					{'Comenzar pedido'}
				</DpButton>
			</Box>
		</Box>
	</Drawer>
);
